const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/eclipse.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { checkIfProtectedRouteCanBeSeen } from "@/react/components/shared/ProtectedRoute/useProtectedRoute";
import { planSettingsPath } from "@/react/helpers/urlHelpers";

/**
 * V4 opt-in landing page at /eclipse — a full-screen experience with its own
 * background and hero chrome. Nested under `_minimal` so the AppShell (and side
 * dock) never mounts.
 *
 * Transitional gating bridge: `_minimal` and `_protected` are sibling pathless
 * segments and cannot be nested, so protected-route access is checked in
 * `beforeLoad` here until `_protected` owns the check everywhere.
 */
export const Route = createFileRoute("/_minimal/eclipse")({
  beforeLoad: ({
    context,
    location
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const canSeeProtectedRoute = checkIfProtectedRouteCanBeSeen(location.pathname, currentCommunity);
    if (!canSeeProtectedRoute) {
      redirect({
        to: planSettingsPath(),
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});